exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-border-override .active{background-color:#fff!important;border:none;border-bottom:4px solid #ff375e}.nav-pills .nav-link,.nav-pills .nav-link:hover{color:#313131!important;font-family:Lato,sans-serif;font-size:16px;letter-spacing:0;line-height:19px;text-align:center}.nav-pills .nav-link.active{background-color:#fff!important;border-radius:0!important;font-weight:700;color:#313131!important}.wfh-control{color:#808fa4;border-radius:0}", ""]);

// exports
